import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputNumberInputEvent, InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'app-quantity-counter',
  standalone: true,
  imports: [InputNumberModule, FormsModule],
  templateUrl: './quantity-counter.component.html',
  styleUrl: './quantity-counter.component.scss',
})
export class QuantityCounterComponent implements OnInit {
  @Output() newQuantity = new EventEmitter<any>();
  @Input() initialQuantity: number = 0;
  @Input() min: number | null = null;
  @Input() max: number | null = null;
  firstQuantity!: number;
  changedClass: string = '';

  ngOnInit(): void {
    this.firstQuantity = this.initialQuantity;
  }

  updateQuantity($event: InputNumberInputEvent) {
    // console.log('changing', this.firstQuantity, $event.value);
    this.changedClass = this.firstQuantity !== $event.value ? 'changed' : '';
    this.newQuantity.emit($event.value);
  }
}
